import React, { useContext, useEffect } from 'react';
import { BrowserProvider } from 'ethers';
import EthereumContext from './EthereumContext';
import '../App.css';

function WalletConnect() {
  const { setProvider, setAccount, setNetworkName } = useContext(EthereumContext);

  const connectWallet = async () => {
    if (window.ethereum) {
      try {
        // Demande à l'utilisateur de se connecter à son portefeuille
        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });

        if (accounts.length > 0) {
          const newProvider = new BrowserProvider(window.ethereum);
          setProvider(newProvider);
          setAccount(accounts[0]);

          const network = await newProvider.getNetwork();
          setNetworkName(network.name);
        }
      } catch (err) {
        console.error('Erreur lors de la connexion au portefeuille:', err);
      }
    } else {
      console.error('MetaMask non détecté. Installation nécessaire.');
    }
  };

  useEffect(() => {
    if (window.ethereum) {
      // Écoute le changement de compte
      window.ethereum.on('accountsChanged', (accounts) => {
        if (accounts.length > 0) {
          setAccount(accounts[0]);
        } else {
          setAccount('');
        }
      });

      // Écoute le changement de réseau
      window.ethereum.on('chainChanged', async () => {
        const newProvider = new BrowserProvider(window.ethereum);
        setProvider(newProvider);
        const network = await newProvider.getNetwork();
        setNetworkName(network.name);
      });
    }

    // Nettoyage des écouteurs lors du démontage du composant
    return () => {
      if (window.ethereum && window.ethereum.removeListener) {
        window.ethereum.removeListener('accountsChanged', () => {});
        window.ethereum.removeListener('chainChanged', () => {});
      }
    };
  }, [setAccount, setProvider, setNetworkName]);

  return (
    <button id="wallet-connect-button" onClick={connectWallet}>
      Connect Wallet
    </button>
  );
}

export default WalletConnect;